module.exports = __webpack_public_path__ + "img/pickup.c7651a55.png";